import { Menu } from "lucide-react"
import { useState } from "react"
import { Link } from "@tanstack/react-router"
import {
  Sheet,
  SheetContent,
  SheetTrigger,
} from "@holigral/shared/ui/components/ui/sheet"
import { IconButton } from "@holigral/shared/ui/composed"
import { Lockup } from "@holigral/shared/ui/brand"
import { ButtonLink, useLocale } from "@holigral/shared/routing"
import { useAuth } from "@/auth"
import { LanguageSwitcher } from "@/profile"
import { useT } from "@/i18n"

function NavLinks({ onNavigate }: { onNavigate?: () => void }) {
  const { t } = useT("content")
  const { isAuthenticated } = useAuth()
  const locale = useLocale()

  return (
    <>
      <ButtonLink
        to="/$locale"
        params={{ locale }}
        hash="intro"
        variant="ghost"
        onClick={onNavigate}
      >
        {t("intro")}
      </ButtonLink>
      <LanguageSwitcher />
      {isAuthenticated ? (
        <ButtonLink
          variant="primary"
          className="ml-2"
          to="/dashboard"
          onClick={onNavigate}
        >
          {t("common:nav.dashboard")}
        </ButtonLink>
      ) : (
        <ButtonLink
          variant="primary"
          className="ml-2"
          to="/$locale/auth"
          params={{ locale }}
          onClick={onNavigate}
        >
          {t("getStarted")}
        </ButtonLink>
      )}
    </>
  )
}

export default function Nav() {
  const { t } = useT()
  const [open, setOpen] = useState(false)
  const locale = useLocale()

  return (
    <nav className="sticky top-0 z-50 border-b border-border/40 bg-background/85 backdrop-blur-md">
      <div className="mx-auto flex max-w-250 items-center justify-between px-4 py-3 md:py-4">
        <Link
          to="/$locale"
          params={{ locale }}
          aria-label={t("lockup.home", { appName: t("appName") })}
          className="text-foreground"
        >
          <Lockup
            variant="logo"
            descriptor="Profiling"
            className="block h-14 md:h-20"
          />
        </Link>
        {/* Desktop nav */}
        <div className="hidden items-center gap-1 text-muted-foreground sm:flex">
          <NavLinks />
        </div>
        {/* Mobile hamburger */}
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger
            render={<IconButton variant="ghost" icon={<Menu />} />}
            className="sm:hidden"
          />
          <SheetContent side="right" className="pt-12" showCloseButton>
            <div className="flex flex-col gap-1 px-2 text-muted-foreground">
              <NavLinks
                onNavigate={() => {
                  setOpen(false)
                }}
              />
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </nav>
  )
}
